import { DangerIcon } from '@/components/Icons';
import { StatusValue } from '@/shared';
import { isActionRequired } from '@/utils';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

interface PerformActionProps {
  status: StatusValue;
  className?: string;
}

export const PerformAction = ({ className, status }: PerformActionProps) => {
  const { t } = useTranslation();

  const toHide = !isActionRequired(status);

  return (
    <div
      className={twMerge(
        'flex items-center gap-1 text-orange-500',
        toHide && 'hidden',
        className,
      )}
    >
      <DangerIcon />
      <span className="text-sm font-bold">{t('perform_action')}</span>
    </div>
  );
};
